<template>
  <div class="main-container" v-loading="isLoading">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="left">
          <div class="top">
            <div class="platform-data">
              <div class="title">平台数据</div>
              <div class="data-list">
                <div>
                  <span>{{ indexData.sumBalance }}</span>
                  总充值金额
                </div>
                <div class="border-right">
                  <span>{{ indexData.todayBalance }}</span>
                  今日充值金额
                </div>
                <div>
                  <span>{{ indexData.yesterdayUser }}</span>
                  昨日新增人数
                </div>
              </div>
            </div>
            <div class="source-box">
              <div class="title">
                客户来源
                <div>
                  统计时间段：
                  <el-date-picker
                    style="margin: 0 10px"
                    size="small"
                    class="date-input"
                    v-model="sourceDate"
                    type="daterange"
                    align="right"
                    unlink-panels
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="handleSourceDateChange"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="data-list">
                <div>
                  <span>{{ indexData.wxUser }}</span>
                  微信来源人数
                </div>
                <!-- <div>
                  <span>123480.00</span>
                  抖音来源人数
                </div> -->
              </div>
            </div>
          </div>
          <div class="list-box">
            <div class="brand">
              <div class="title">品牌点击数据(前10)</div>
              <div class="list">
                <div class="item list-header">
                  <div class="name">品牌名称</div>
                  <div class="num">点击次数</div>
                </div>
                <div
                  class="item"
                  v-for="(item, index) in indexData.brandList"
                  :key="index"
                >
                  <div class="name">{{ item.brandName }}</div>
                  <div class="num">{{ item.count }}</div>
                </div>
              </div>
              <div class="search-box">
                查询其它品牌
                <el-input
                  v-model="brandName"
                  class="input"
                  placeholder="请输入品牌名称"
                  size="small"
                ></el-input>
                <div class="btn" @click="getIndexBrandData">查询</div>
              </div>
            </div>
            <div class="product">
              <div class="title">产品关注度</div>
              <div class="list">
                <div class="item list-header">
                  <div class="name">产品名称</div>
                  <div class="num">点击次数</div>
                  <div class="num">咨询次数</div>
                </div>
                <div
                  class="item"
                  v-for="(item, index) in indexData.productList"
                  :key="index"
                >
                  <div class="name">{{ item.productName }}</div>
                  <div class="num">{{ item.count }}</div>
                  <div class="num">{{ item.consultCount }}</div>
                </div>
              </div>
              <div class="search-box">
                查询其它产品
                <el-input
                  v-model="productName"
                  class="input"
                  placeholder="请输入产品名称/ID"
                  size="small"
                ></el-input>
                <div class="btn" @click="toProductInfo">查询</div>
              </div>
            </div>
          </div>
        </div>
        <div class="recharge-box">
          <div class="title">每日充值金额列表</div>
          <div class="filter">
            选择时间查询
            <div>
              <el-date-picker
                style="margin: 0 10px"
                size="small"
                class="date-input"
                v-model="rechargeDate"
                type="daterange"
                align="right"
                unlink-panels
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <div class="btn" @click="handleRechargeChange">查询</div>
            </div>
          </div>
          <div class="recharge-list-box">
            <div class="recharge-item list-header">
              <div class="date">日期</div>
              <div class="num">充值金额</div>
            </div>
            <div class="recharge-list">
              <div
                class="recharge-item"
                v-for="(item, index) in rechargeList"
                :key="index"
              >
                <div class="date">{{ item.day }}</div>
                <div class="num">{{ item.amount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="查询品牌点击次数"
      :visible.sync="brandVisible"
      width="460px"
      class="dialog"
      top="10%"
    >
      <div class="brand-info">
        <div class="row">
          <div class="label">品牌名称:</div>
          <div class="value">
            {{ brandInfo.brandName }}
          </div>
        </div>
        <div class="row">
          <div class="label">点击次数:</div>
          <div class="value">
            {{ brandInfo.count }}
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="brandVisible = false"
        >
          确 定
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../components/common/header';
import { staticImg } from '@/config'; // oss 图片地址
import dayjs from 'dayjs';
export default {
  components: {
    Header
  },
  name: 'Index',
  data() {
    return {
      isLoading: 0,
      title: {
        // 页面标题
        firstTitile: '首页'
      },
      staticImg: staticImg,
      sourceDate: [],
      rechargeDate: [],
      brandVisible: false,
      indexData: {},
      rechargeList: [],
      brandName: '',
      brandInfo: {},
      productName: ''
    };
  },
  mounted() {
    this.rechargeDate = [dayjs().subtract(1, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')];
    this.getIndexData();
    this.getIndexBalance();
  },
  methods: {
    getIndexData() {
      this.loading++;
      this.httpGet(this.$root.getIndexData, {
        begin: this.sourceDate[0] || '',
        end: this.sourceDate[1] || ''
      }).then(
        (res) => {
          this.loading--;
          this.indexData = res;
        },
        () => {
          this.loading--;
        }
      );
    },
    handleSourceDateChange(){
      this.getIndexData();
    },
    getIndexBrandData(){
      this.loading++;
      this.httpGet(this.$root.getIndexBrandData, {
        brandName: this.brandName
      }).then(
        (res) => {
          this.loading--;
          this.brandInfo = res;
          this.brandVisible = true;
        },
        () => {
          this.loading--;
        }
      );
    },
    getIndexBalance(){
      this.loading++;
      this.httpGet(this.$root.getIndexBalance, {
        begin: this.rechargeDate[0] || '',
        end: this.rechargeDate[1] || ''
      }).then(
        (res) => {
          this.loading--;
          this.rechargeList = res.list;
        },
        () => {
          this.loading--;
        }
      );
    },
    handleRechargeChange(){
      this.getIndexBalance();
    },
    toProductInfo(){
      this.$router.push({
        name: 'statistics',
        query: {
          productName: this.productName
        }
      });
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
@import '~assets/public.styl';

.container {
  padding: 0 !important;
}

.content {
  background: #F6F6F6 !important;
  padding: 24px !important;
  flex-x(flex-start, flex-start);
  height: 100%;
  overflow: hidden;
  .title{
    flex-x(flex-start);
    word(16px, #333);
    font-weight: bold;
  }
  .left{
    flex: 1;
    height: 100%;
    margin-right: 10px;
    flex-y(flex-start, flex-start);
    .top{
      width: 100%;
      height: 140px;
      flex-x();
      .title{
        width: 100%;
        height: 50px;
        padding: 0 24px;
        box-sizing: border-box;
        flex-x();
        div{
          word(12px, #333);
          font-weight: normal;
          flex-x();
        }
      }
      .data-list{
        width: 100%;
        flex-x(space-between);
        word(14px, #666);
        >div{
          flex-y();
          flex: 1;
          margin-top: 6px;
          span{
            word(32px, #333);
            margin-bottom: 6px;
            // font-weight: bold;
          }
        }
        .border-right{
          border-right: 1px solid #ccc;
        }
      }
      .platform-data{
        flex: 1;
        margin-right: 10px;
        min-width: 600px;
        height: 100%;
        background: #fff;
        flex-y(flex-start, flex-start);
        border-radius: 10px;
        box-sizing: border-box;
      }
      .source-box{
        width: 480px;
        height: 100%;
        background: #fff;
        flex-y(flex-start, flex-start);
        border-radius: 10px;
        box-sizing: border-box;
      }
    }
    .list-box{
      width: 100%;
      flex: 1;
      flex-x();
      margin-top: 12px;
      .title{
        height: 60px;
        flex-x(flex-start);

      }
      .brand, .product{
        flex: 1;
        height: 100%;
        margin-right: 10px;
        border-radius: 10px;
        background: #fff;
        padding: 0 20px;
        box-sizing: border-box;
        flex-y(flex-start, flex-start);
      }
      .list{
        width: 100%;
        flex: 1;
        flex-y(flex-start);
        // background: red;
        overflow-y: auto;
        .item{
          width: 100%;
          height: 36px;
          flex-x();
          word(14px, #333);
          .name{
            flex: 1;
          }
          .num{
            width: 120px;
            flex-x(center);
          }
        }
        .list-header{
          word(14px, #666);
        }
      }
    }
    .search-box{
      width: 100%;
      height: 60px;
      flex-x(center);
      word(14px, #333);
      .input{
        width: 160px;
        margin-left: 16px;
        margin-right: 8px;
      }
      .btn{
        width: 64px;
      }
    }
  }
  .recharge-box{
    width: 500px;
    height: 100%;
    background: #fff;
    border-radius: 10px;
    padding: 18px 16px 30px 24px;
    box-sizing: border-box;
    flex-y(flex-start, flex-start);
    .filter{
      width: 100%;
      height: 60px;
      flex-x();
      word(14px, #666);
      border-bottom: 1px solid #EBEBEB;
      >div{
        flex-x();
        .btn{
          width: 64px;
        }
      }
    }
    .recharge-list-box{
      width: 100%;
      overflow: hidden;
      flex: 1;
      height: 100%;
      flex-y(flex-start, flex-start);
      .recharge-list{
        width: 100%;
        flex-y(flex-start, flex-start);
        flex: 1;
        overflow-y: auto;
      }
      .recharge-item{
        width: 100%;
        height: 32px;
        flex-x();
        word(14px, #333);
        flex-shrink: 0;

        &.list-header{
          word(14px, #666);
          margin-top: 10px;
        }

        .date{
          min-width: 120px;
          flex-x(center);
        }
        .num{
          min-width: 120px;
          flex-x(center);
        }
      }
    }
  }
}
.brand-info{
  padding: 20px 0;
  .row{
    flex-x(center);
    height: 36px;
    .label{
      width: 80px;
    }
    .value{
      width: 100px;
    }
  }
}
</style>
